import script from "./GitRepoAdvancedTab.vue?vue&type=script&setup=true&lang=js"
export * from "./GitRepoAdvancedTab.vue?vue&type=script&setup=true&lang=js"

import "./GitRepoAdvancedTab.vue?vue&type=style&index=0&id=0e99fed0&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e99fed0"]])

export default __exports__